const { withStyles, Button } = require("@material-ui/core");
import CancelIcon from "@material-ui/icons/Clear";

const styles = (theme) => ({
  container: {
    width: 338,
    height: 80,
    maxWidth: 600,
    minHeight: 85,
    borderRadius: 2,
    backgroundColor: theme.ModalBGColor,
    boxShadow: "0 0px 8px 0 rgba(0,0,0,0.5)",
    display: "flex",
    padding: "16px",
    boxSizing: "border-box",
    userSelect: "none",
    pointerEvents: "all",
    flexDirection: "column",
  },
  noBoxShadow: {
    boxShadow: "none",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: theme.headerTextFontSize,
    color: theme.TextColor,
  },
  cancelIcon: {
    color: theme.gridTextColor,
    cursor: "pointer",
  },
  button: {
    padding: 0,
    marginTop: 12,
    maxWidth: 170,
    fontSize: theme.textFontSize,
  },
});
const NewShipmentsFeedbackPanel = ({
  classes,
  handleAddClick,
  onClose,
  hideCloseAction,
  hidePanelShadow,
}) => {
  return (
    <div
      className={`${classes.container} ${
        hidePanelShadow ? classes.noBoxShadow : ""
      }`}
    >
      <div className={classes.headerContainer}>
        <div>New shipments are available</div>
        {!hideCloseAction && (
          <CancelIcon
            classes={{ root: classes.cancelIcon }}
            onClick={onClose}
          />
        )}
      </div>
      <Button
        variant="outlined"
        color="primary"
        className={classes.button}
        onMouseDown={handleAddClick}
      >
        + Add shipments to plan
      </Button>
    </div>
  );
};

export default withStyles(styles)(NewShipmentsFeedbackPanel);
